import axios from 'axios'

export default {
  state: {
    seo: []
  },
  actions: {
    showSeo ({ commit }) {
      console.log('teste')
      return axios.get(`/seo/indexSeo.php`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Allow-Control-Allow-Origin': '*'
        }
      }).then(response => {
        console.log('response')
        commit('setSeo', response.data)
        return response
      }).catch(error => {
        console.log(error)
      })
    }
  },
  mutations: {
    setSeo (state, seo) {
      state.seo = seo
    }
  },
  getters: {
    seo (state) {
      return state.seo
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/seo.js